module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "margin-top",
    attrs: {
      "id": "result"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "alert alert-warning"
  }, [_vm._v("Идет загрузка...")])]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "error"
  }, [_c('div', {
    staticClass: "alert alert-warning"
  }, [_vm._v("Ошибка Получения данных!")])]) : _vm._e(), _vm._v(" "), (_vm.notfound) ? _c('div', {
    staticClass: "error"
  }, [_c('div', {
    staticClass: "alert alert-warning"
  }, [_vm._v("Не удалось найти статью в словаре!")])]) : _vm._e(), _vm._v(" "), (_vm.content) ? _c('div', {
    staticClass: "success"
  }, _vm._l((_vm.content), function(article) {
    return _c('div', {
      staticClass: "panel panel-default margin-bottom"
    }, [_c('div', {
      staticClass: "panel-heading"
    }, [_c('strong', [_c('a', {
      attrs: {
        "href": '#/term/' + article.id
      }
    }, [_vm._v(_vm._s(article.word_orig))])]), _vm._v(" "), _c('small', [_vm._v("[" + _vm._s(article.volume) + " : " + _vm._s(article.fpage)), (article.fpage !== article.lpage) ? _c('span', [_vm._v(" - " + _vm._s(article.lpage))]) : _vm._e(), _vm._v("]")]), _vm._v(" "), _vm._m(0, true)]), _vm._v(" "), _c('div', {
      staticClass: "panel-body text-justify",
      domProps: {
        "innerHTML": _vm._s(article.word_desc)
      }
    }, [_vm._v("\n                        " + _vm._s(article.word_desc) + "                  \n                    ")])])
  })) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-default btn-xs pull-right",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#infoModal",
      "title": "Сообщить об ошибке!"
    }
  }, [_c('span', {
    staticClass: "fa fa-exclamation-triangle text-danger",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-441f9c93"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Search.vue
// module id = 30
// module chunks = 0